export const UPDATE_LOCALE = 'intl/UPDATE_LOCALE'

export const updateLocale = settings => ({
  type: UPDATE_LOCALE,
  settings,
})
